import './OutOfOrder.css';

const OutOfOrderPage = () => {
  return (
    <div className="outoforder-wrapper">
      <div>
        <svg
          aria-hidden="true"
          className="outoforder-logo"
          viewBox="0 0 24 24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2 21.8v-1.6H22v1.6ZM3 17c-.4 0-.5-.2-.6-.7L2 13.6c0-.5 0-1 .4-1s.4.4.5 1a3.6 3.6 0 0 0 3.9 2.9c1.6 0 3-.8 3-2.4 0-1.5-1.3-2-3.5-3-2.5-1-4-1.8-4-4S3.7 3 6.5 3c1.5 0 2.2.5 3.5.6a.4.4 0 0 1 .5.4l.2 3.2c0 .3 0 .4-.4.4s-.5-.4-.6-.9A3 3 0 0 0 6.6 4C5 4 3.9 4.9 3.9 6S5 8 7 8.7c2.5 1 4.6 1.6 4.6 4.4a4.5 4.5 0 0 1-4.8 4.5c-1.5 0-2.5-.7-3.7-.7Zm12 0c-.2 0-.4 0-.4-.3 0-.4.6-.3 1.2-.5.8-.3.8-1 .8-1.7v-7c0-.7 0-1-1.2-1-1.3 0-1.8.1-2 .9-.4.9-.2 1.2-.7 1.2-.3 0-.4-.2-.4-.5V6c.1-.3.1-.6.4-.6H22v1.7c-.3-.6-.8-.6-2-.6-1.1 0-1.2.2-1.2.9v7c0 .7 0 1.4.8 1.7.6.2 1.1.1 1.2.5 0 .2-.2.3-.5.3Z"
            fill="currentColor"
          ></path>
        </svg>
        <h3>Wir bitten um Entschuldigung, aktuell führen wir Wartungsarbeiten an unserem Abo-Bestellservice durch.</h3>
        <p>In der Regel sollte die Unterbrechung maximal eine Stunde betragen.</p>
        <p>
          Sollten Sie Hilfe benötigen, kontaktieren Sie uns bitte unter <a href="mailto:digitalabo@derStandard.at">digitalabo@derStandard.at</a>. Weitere
          Informationen finden Sie auf den <a href="https://abo.derstandard.at/aboservice/">Aboservice-Seiten</a>.
        </p>
        <p>
          <strong>Vielen Dank für Ihr Verständnis!</strong>
        </p>
        <p>
          Weiter zu{' '}
          <a
            className="outoforder-link"
            href="https://www.derstandard.at/"
          >
            derStandard.at
          </a>
          .
        </p>
      </div>
    </div>
  );
};

export default OutOfOrderPage;
